import AdvertiseHeader from "./AdvertiseHeader";
import ShowUserPhone from "./ShowUserPhone";
import CharacterLimit from './CharacterLimit';
import HomeSearch from './HomeSearch';
import AdContactFormToggle from './AdContactFormToggle';
import MailCountCookie from './MailCountCookie';

export const components = () => {
  new AdvertiseHeader();
  new ShowUserPhone();
  new CharacterLimit();
  new HomeSearch();
  new AdContactFormToggle();
  window.mcc = new MailCountCookie();
};



// WEBPACK FOOTER //
// ./resources/assets/js/Components/Components.js